import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import PropTypes from 'prop-types'

function SEO({ description, canonical, title, structuredData, url, image }) {
  return (
    <StaticQuery
      query={detailsQuery}
      render={data => {
        const metaDescription = description || data.site.siteMetadata.description
        const titleTemplate = !title.includes("Firetide") && title.length < 51 ? title + " | " + data.site.siteMetadata.title : title
        const urlPrefix = (image.substring(0,4) !== "http" ? data.site.siteMetadata.siteUrl : "")

        return (
          <>
            <title>{titleTemplate}</title>
            <meta name="title" content={title} />
            <meta name="description" content={metaDescription} />
            <meta name="robots" content="index, follow" />
            <link rel="canonical" href={(canonical.substring(0,4) !== "http" ? urlPrefix : "") + canonical} />
            <meta property="og:site_name" content={data.site.siteMetadata.title} />
            <meta property="og:title" content={title} />
            <meta property="og:url" content={data.site.siteMetadata.siteUrl + url} />
            <meta property="og:description" content={metaDescription} />    
            <meta property="og:type" content="website" /> 
            <meta property="og:locale" content="en_US" /> 
            <meta property="og:image" content={urlPrefix + image} />    
            <meta name="twitter:card" content="summary_large_image" />    
            <meta name="twitter:creator" content={data.site.siteMetadata.author} />    
            <meta name="twitter:title" content={title} />    
            <meta name="twitter:description" content={metaDescription} />    
            <meta name="twitter:site" content="@unicomglobal" /> 
            <meta name="twitter:image" content={urlPrefix + image} />    
          </>  
        )
      }}
    />
  )
}

SEO.propTypes = {
  description: PropTypes.string,
  canonical: PropTypes.string,
  title: PropTypes.string.isRequired,
  url: PropTypes.string,
  image: PropTypes.string,
}

export default SEO

const detailsQuery = graphql`
  query DefaultSEOQuery {
    site {
      siteMetadata {
        title
        description
        author
        siteUrl
      }
    }
  }
`
